/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IImageViewProps } from './nos-image';

/**
 * Render the thumbnail item images.
 * @param props - The image view props.
 * @returns Return HTML having IImageViewProps props with image.
 */
export const imageView: React.FC<IImageViewProps> = (props: IImageViewProps) => {
    const { paragraph, image, imageItem } = props;
    return (
        <Node {...image}>
            {imageItem}
            {paragraph}
        </Node>
    );
};

export default imageView;
